import roles from './roles'

const install = function (Vue) {
  Vue.directive('roles', roles)
}

if (window.Vue) {
  window['roles'] = roles
  Vue.use(install); // eslint-disable-line
}

roles.install = install
export default roles
